// extracted by mini-css-extract-plugin
module.exports = {"container":"assignmentform_container__1EGPD","close_button":"assignmentform_close_button__KYdaU","form":"assignmentform_form__1wxvU"};